import { HttpService } from 'services/HttpService';
import { PortfolioModel } from 'pages/PortfoliosPage/PortfolioModel';

export class PortfolioService {
  static baseUrl = '/frontend';

  static async addManagers(portfolioId: string, managers: string[]): Promise<any> {
    const url = `${PortfolioService.baseUrl}/access/portfolios/${portfolioId}/managers/add`;
    const body = {
      managers
    };
    return HttpService.post(url, body);
  };

  static async addPowerplant(portfolioId: string, powerplantId: string, powerplantName: string): Promise<any> {
    const url = `${PortfolioService.baseUrl}/access/portfolios/${portfolioId}/powerplants/add`;
    const body = {
      powerplantId: powerplantId,
      powerplantName: powerplantName
    };
    return HttpService.post(url, body);
  };

  static async createPortfolio(name: string, description: string): Promise<any> {
    const url = `${PortfolioService.baseUrl}/access/portfolios`;
    const body = {
      name,
      description
    };
    return HttpService.post(url, body);
  };

  static async deletePortfolio(portfolioId: string): Promise<any> {
    const url = `${PortfolioService.baseUrl}/access/portfolios/${portfolioId}`;
    return HttpService.delete(url);
  };

  static async getPortfolio(portfolioId: string): Promise<PortfolioModel> {
    return HttpService.get(`${PortfolioService.baseUrl}/access/portfolios/${portfolioId}`);
  };

  static async getPortfolios(): Promise<PortfolioModel[]> {
    return HttpService.get(`${PortfolioService.baseUrl}/access/portfolios/list`);
  };

  static async modifyPortfolio(portfolioId: string, name: string | null, description: string | null): Promise<any> {
    const url = `${PortfolioService.baseUrl}/access/portfolios/${portfolioId}`;
    const body = {
      name,
      description
    };
    return HttpService.put(url, body);
  };

  static async removeManagers(portfolioId: string, managers: string[]): Promise<any> {
    const url = `${PortfolioService.baseUrl}/access/portfolios/${portfolioId}/managers/remove`;
    const body = {
      managers
    };
    return HttpService.post(url, body);
  };

  static async removePowerplant(portfolioId: string, powerplantId: string): Promise<any> {
    const url = `${PortfolioService.baseUrl}/access/portfolios/${portfolioId}/powerplants/remove`;
    const body = {
      powerplantId: powerplantId
    };
    return HttpService.post(url, body);
  };
}
